import {type AppBskyFeedDefs} from '@atproto/api'
import {useQuery} from '@tanstack/react-query'

import {STALE} from '#/state/queries'
import {usePreferencesQuery} from '#/state/queries/preferences'
import {useAgent} from '#/state/session'

export const DEFAULT_LIMIT = 5

// Static list of Batesky featured feeds shown in Explore feed previews
// Format: { handle: string, rkey: string }
const BATESKY_FEATURED_FEEDS = [
  {handle: 'batesky.app', rkey: 'aaahjvrm3fhdu'}, // Bators feed
  {handle: 'crshort81.bsky.social', rkey: 'aaajejiwjged6'},
  {handle: 'unclemikey.gay', rkey: 'balls'},
]

export const createGetSuggestedFeedsQueryKey = () => ['suggested-feeds']

export function useGetSuggestedFeedsQuery({enabled}: {enabled?: boolean}) {
  const agent = useAgent()
  const {data: preferences} = usePreferencesQuery()

  return useQuery({
    enabled: !!preferences && enabled !== false,
    staleTime: STALE.MINUTES.THREE,
    queryKey: createGetSuggestedFeedsQueryKey(),
    queryFn: async () => {
      // Fetch all featured feeds metadata in parallel
      const feedResults = await Promise.all(
        BATESKY_FEATURED_FEEDS.map(async ({handle, rkey}) => {
          try {
            // First resolve the handle to a DID
            const resolveRes = await agent.resolveHandle({handle})
            const did = resolveRes.data.did
            const uri = `at://${did}/app.bsky.feed.generator/${rkey}`

            // Then fetch the feed generator
            const res = await agent.app.bsky.feed.getFeedGenerator({feed: uri})
            return res.data.view
          } catch {
            return null
          }
        }),
      )

      // Filter out nulls (failed fetches)
      const feeds = feedResults.filter(
        (feed): feed is AppBskyFeedDefs.GeneratorView => feed !== null,
      )

      return {feeds}
    },
  })
}
